import React, { useEffect } from "react";
import { config } from "../config/config";
import "datatables.net-bs5";
import "datatables.net";
import Swal from "sweetalert2";
import { getAuthToken } from "../services/tokenService.service";
import { userService } from "../services/user.service";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import $ from "jquery";
import { Modal } from "bootstrap";

const User = () => {
  useEffect(() => {
    const token = getAuthToken();
    const table = $("#userTable").DataTable({
      processing: true,
      serverSide: true,
      ajax: {
        url: config.baseURL + "/users",
        type: "GET",
        beforeSend: function (xhr) {
          xhr.setRequestHeader("Authorization", "Bearer " + token);
          xhr.setRequestHeader("X-Requested-With", "XMLHttpRequest");
        },
      },
      columns: [
        {
          data: "DT_RowIndex",
          name: "DT_RowIndex",
          orderable: false,
          searchable: false,
        },
        { data: "name", name: "name" },
        { data: "username", name: "username" },
        { data: "email", name: "email" },
        { data: "roles", name: "roles" },
        {
          data: "action",
          name: "action",
          orderable: false,
          searchable: false,
        },
      ],
    });

    (window as any).editUser = openEditModal;

    (window as any).deleteUser = async (id: number) => {
      Swal.fire({
        title: "Yakin?",
        text: "User akan dihapus!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Ya, hapus!",
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            await userService.deleteUser(id);
            $("#userTable").DataTable().ajax.reload(undefined, false);
            Swal.fire("Dihapus!", "User berhasil dihapus.", "success");
          } catch (err) {
            Swal.fire("Gagal!", "Terjadi kesalahan.", "error");
          }
        }
      });
    };

    return () => {
      table.destroy();
    };
  }, []);

  const openAddModal = () => {
    $("#userId").val("");
    ($("#userForm")[0] as HTMLFormElement).reset();
    $("#password").attr("placeholder", "");

    const modalElement = document.getElementById("formModal")!;
    const modal = new Modal(modalElement);
    modal.show();
  };
  const openEditModal = async (id: number) => {
    const user = await userService.getUser(id);
    const role = user.roles?.[0];

    $("#userId").val(user.id);
    $("#name").val(user.name);
    $("#username").val(user.username ?? "");
    $("#email").val(user.email);
    $("#password")
      .val("")
      .attr("placeholder", "Kosongkan jika tidak ingin mengubah password");
    $("#roles").val(typeof role === "string" ? role : role?.name ?? "");

    const modalElement = document.getElementById("formModal")!;
    const modal = new Modal(modalElement);
    modal.show();
  };

  const handleSubmit = async () => {
    const id = $("#userId").val();
    const data = {
      name: $("#name").val(),
      username: $("#username").val(),
      email: $("#email").val(),
      password: $("#password").val(),
      roles: [$("#roles").val()],
    };

    try {
      if (id) {
        await userService.updateUser(String(id), data);
      } else {
        await userService.createUser(data);
      }

      const modalElement = document.getElementById("formModal")!;
      const modal = Modal.getInstance(modalElement);
      modal?.hide();

      $("#userTable").DataTable().ajax.reload(undefined, false);
      Swal.fire("Sukses", "User berhasil disimpan", "success");
    } catch (err) {
      Swal.fire("Gagal", "Terjadi kesalahan", "error");
    }
  };

  return (
    <div className="p-4">
      <h2 className="mb-3">Manage Users</h2>
      <button className="btn btn-success mb-3" onClick={() => openAddModal()}>
        Tambah User
      </button>
      <table id="userTable" className="table table-bordered table-striped">
        <thead className="table-success">
          <tr>
            <th>No</th>
            <th>Name</th>
            <th>Username</th>
            <th>Email</th>
            <th>Roles</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody></tbody>
      </table>
      <div
        className="modal fade"
        id="formModal"
        tabIndex={-1}
        aria-labelledby="formModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="formModalLabel">
                Form User
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
              ></button>
            </div>
            <div className="modal-body">
              <form id="userForm">
                <input type="hidden" id="userId" />
                <div className="mb-3">
                  <label className="form-label">Name</label>
                  <input
                    type="text"
                    id="name"
                    className="form-control"
                    required
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label">Username</label>
                  <input
                    type="text"
                    id="username"
                    className="form-control"
                    required
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label">Email</label>
                  <input
                    type="email"
                    id="email"
                    className="form-control"
                    required
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label">Password</label>
                  <input
                    type="password"
                    id="password"
                    className="form-control"
                    required
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label">Role</label>
                  <select
                    id="roles"
                    className="form-select"
                    defaultValue=""
                    required
                  >
                    <option value="" disabled>
                      Pilih Role
                    </option>
                    <option value="super-admin">Super Admin</option>
                    {/* <option value="admin">Admin</option> */}
                    <option value="user">User</option>
                  </select>
                </div>
              </form>
            </div>
            <div className="modal-footer">
              <button className="btn btn-secondary" data-bs-dismiss="modal">
                Tutup
              </button>
              <button
                className="btn btn-primary"
                onClick={() => handleSubmit()}
              >
                Simpan
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default User;
